// Post Validation Session Konseling

import axios from "axios";
import {
  POST_VALIDATION_SESSION_KONSELING_FAIL,
  POST_VALIDATION_SESSION_KONSELING_REQUEST,
  POST_VALIDATION_SESSION_KONSELING_RESET,
  POST_VALIDATION_SESSION_KONSELING_SUCCESS,
} from "../constants/ValidationSessionKonselingConstants";
import {
  DUMMY_PDULI_VERIFY_CODE,
  DUMMY_PDULI_VERIFY_CODE_2,
  DUMMY_PDULI_VERIFY_CODE_2_COUNSELEE,
} from "../dummy/konseling_dummy";
import { UserDataPduliEncode } from "../function/base64Function";
import { API_POST_VALIDATION_SESSION_KONSELOR } from "../init/urlApi";

export const RPostValidationSessionKonseling = () => async (dispatch) => {
  dispatch({
    type: POST_VALIDATION_SESSION_KONSELING_RESET,
  });
};

export const PostValidationSessionKonseling = (code) => async (dispatch) => {
  try {
    dispatch({
      type: POST_VALIDATION_SESSION_KONSELING_REQUEST,
    });

    const config = {
      headers: {},
    };
    const { data: data } = await axios.post(
      API_POST_VALIDATION_SESSION_KONSELOR(),
      {
        token: code,
      },
      config
    );

    // let data = DUMMY_PDULI_VERIFY_CODE_2; // untuk dummy
    // let data = DUMMY_PDULI_VERIFY_CODE_2_COUNSELEE;

    let tmp = {
      idUserPduli: data.data.userId,
      session: data.data.sessionId,
      kodeVC: data.data.token,
      typeUser: data.data.userType,
      token: data.token,
    };
    // console.log("data send api pduli", tmp);

    let url = UserDataPduliEncode(
      tmp.idUserPduli,
      tmp.session,
      tmp.kodeVC,
      tmp.typeUser,
      tmp.token
    );

    dispatch({
      type: POST_VALIDATION_SESSION_KONSELING_SUCCESS,
      payload: { session: data, url: url },
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: POST_VALIDATION_SESSION_KONSELING_FAIL,
      payload: message,
    });
  }
};
